import { usePopover } from 'minimal-shared/hooks';

import Popover from '@mui/material/Popover';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';

import { useLocale } from 'src/locales/localization-provider';

import { Iconify } from 'src/components/iconify';
import { FlagIcon } from 'src/components/flag-icon';
import { useTranslate } from 'src/locales';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { t } from 'i18next';

// ----------------------------------------------------------------------

export function LanguagePopover({ data = [], sx, ...other }) {
  const { open, onClose, onOpen, anchorEl } = usePopover();
  const { locale, setLocale } = useLocale();
  const { i18n } = useTranslation();

  const currentLang = data.find((lang) => lang.value === locale);

  const handleChangeLang = (newLang) => {
    localStorage.setItem('i18nextLng', newLang);
    i18n.changeLanguage(newLang);
    setLocale(newLang);
    onClose();
  };

  const renderButton = () => (
    <IconButton
      onClick={onOpen}
      aria-label="language selector"
      sx={[
        {
          p: 0,
          width: 40,
          height: 40,
          ...(open && { bgcolor: 'action.selected' }),
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      {...other}
    >
      {/* <FlagIcon code={currentLang?.countryCode} /> */}
      <Iconify
        icon="ic:outline-language"
        width="22"
        height="22"
        sx={{
          color: 'rgba(106, 110, 113, 1)',
          // color: 'primary',
        }}
      />
    </IconButton>
  );

  const renderMenuList = () => (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <MenuList sx={{ width: 160, minHeight: 72 }}>
        {data?.map((option) => (
          <MenuItem
            key={option.value}
            selected={option.value === currentLang?.value}
            onClick={() => handleChangeLang(option.value)}
            sx={{ gap: 2 }}
          >
            <FlagIcon code={option.countryCode} />
            {option.label}
          </MenuItem>
        ))}
      </MenuList>
    </Popover>
  );

  return (
    <>
      {renderButton()}
      {renderMenuList()}
    </>
  );
}
